<template>
  <div class="app-container" ref="echartsWrapper">
    <el-button
      icon="el-icon-pie-chart"
      :type="showType == '预算图表' ? 'success' : ''"
      @click="setType('预算图表')"
    >
      预算图表
    </el-button>
    <el-button
      icon="el-icon-pie-chart"
      :type="showType == '数量图表' ? 'success' : ''"
      @click="setType('数量图表')"
    >
      数量图表
    </el-button>
    <el-divider />
    <div class="charts_wrap" v-show="showType == '预算图表'">
      <div
        class="charts_con"
        id="charts_con_1"
        :style="{ width: '1700px', height: fullHeight }"
      ></div>
    </div>
    <div class="charts_wrap" v-show="showType == '数量图表'">
      <div
        class="charts_con"
        id="charts_con_2"
        :style="{ width: '1700px', height: fullHeight }"
      ></div>
    </div>
  </div>
</template>

<script>
import models from '@/models';
import api from '@/api';

export default {
  name: 'index',
  data() {
    const statistics = models.statistics();
    return {
      statistics,
      opSelected: null,
      isShow: true,
      nameArr: [],
      budgetArr: [],
      numArr: [],
      showType: '预算图表',
      fullWidth: 0,
      fullHeight: 0,
      budgetFieldName: 'subtotalBudget',
      // numFieldName:""
      option: {
        color: ['#838c92'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          data: [
            '达产',
            '正在支撑',
            '1个月',
            '3个月',
            '6个月及以上',
            '暂停失效'
          ],
          textStyle: { color: '#fff' },
          selected: {
            达产: true,
            正在支撑: false,
            '1个月': false,
            '3个月': false,
            '6个月及以上': false,
            暂停失效: false
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '8%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisLabel: { color: '#fff' },
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value',

            axisLabel: { color: '#fff' }
          }
        ],

        series: [
          {
            name: '达产',
            type: 'bar',
            data: [],
            itemStyle: { color: '#00bfb7' }
          },
          {
            name: '正在支撑',
            type: 'bar',
            data: [],
            itemStyle: { color: '#ff9080' }
          },
          {
            name: '1个月',
            type: 'bar',
            data: [],
            itemStyle: { color: '#18b9dc' }
          },
          {
            name: '3个月',
            type: 'bar',
            data: [],
            itemStyle: { color: '#dcda18' }
          },
          {
            name: '6个月及以上',
            type: 'bar',
            data: [],
            itemStyle: { color: '#e062ae' }
          },
          {
            name: '暂停失效',
            type: 'bar',
            data: [],
            itemStyle: { color: '#f90723' }
          }
        ]
      }
    };
  },
  async created() {
    const { data } = await api.statistics.summary();
    this.statistics.data = data;

    this.listData = this.sortByKey(this.statistics.data, 'productionBudget');
    // this.fullWidth = this.$refs.echartsWrapper.clientWidth + 'px';
    this.fullHeight = this.$refs.echartsWrapper.clientHeight - 90 + 'px';

    await this.statistics.data.forEach((item, index) => {
      if (index == 0) {
        return;
      }
      this.nameArr.push(item.businessName);
    });

    this.option.xAxis[0].data = this.nameArr;
    this.setType('预算图表');
  },
  methods: {
    onDownload() {
      open('api/statistics/exportExcel', '_black');
    },
    setType(str) {
      this.showType = str;
      if (str == '预算图表') {
        this.getSeriesData(1);
        this.drawLine('charts_con_1');
      }
      if (str == '数量图表') {
        this.getSeriesData(2);
        this.drawLine('charts_con_2');
      }
    },
    //加载预算数据
    async getSeriesData(num) {
      this.option.series.forEach(item => {
        item.data = [];
      });
      if (num == 1) {
        await this.statistics.data.forEach((item, index) => {
          if (index == this.statistics.data.length - 1) {
            return;
          }
          this.option.series[0].data.push(item.productionBudget);
          this.option.series[1].data.push(item.normalBudget);
          this.option.series[2].data.push(item.oneMonthBudget);
          this.option.series[3].data.push(item.threeMonthBudget);
          this.option.series[4].data.push(item.sixMonthBudget);
          this.option.series[5].data.push(item.failBudget);
        });
      } else {
        await this.statistics.data.forEach((item, index) => {
          if (index == this.statistics.data.length - 1) {
            return;
          }
          this.option.series[0].data.push(item.productionAmount);
          this.option.series[1].data.push(item.normalAmount);
          this.option.series[2].data.push(item.oneMonthAmount);
          this.option.series[3].data.push(item.threeMonthAmount);
          this.option.series[4].data.push(item.sixMonthAmount);
          this.option.series[5].data.push(item.failAmount);
        });
      }
    },
    drawLine(id) {
      var myChart = this.$echarts.init(document.getElementById(id));
      myChart.setOption(this.option);
      myChart.on('legendselectchanged', function(obj) {
        this.opSelected = obj.selected;
      });
      setTimeout(function() {
        window.onresize = function() {
          myChart.resize();
        };
      }, 200);
    },
    sortByKey(array, key) {
      return array.sort(function(a, b) {
        var x = a[key];
        var y = b[key];
        return x > y ? -1 : x < y ? 1 : 0;
      });
    }
  }
};
</script>

<style lang="scss" scoped>

.app-container {
  height: calc(100vh - 50px);
  background: #344b58;
  overflow-x: scroll;
}
.charts_wrap {
  width: 100%;
  height: auto;
  position: relative;
}
.tool {
  position: absolute;
  right: 10px;
  top: 10px;
  text-align: center;
  width: 100%;
}
.tool span {
  margin: 0 5px;
  font-size: 13px;
  color: #dcdcdc;
  border-radius: 4px;
  cursor: pointer;
}
.tool span.cur {
  color: #00bfb7;
}
.tool span.cur i {
  background: #00bfb7;
}
.tool span i {
  display: inline-block;
  background: #dcdcdc;
  width: 30px;
  height: 15px;
  border-radius: 3px;
  margin: 0px 4px 0 0;
  position: relative;
  top: 3px;
}
.charts_con {
  margin: 0 auto;
  width: 100%;
  height: 700px;
  color: #fff;
}
</style>
